import { Navigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'

export default function ProtectedRoute({ children }) {
  const { token, hydrated } = useAuth()

  // Wait for Zustand to rehydrate from localStorage before deciding
  if (!hydrated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-app">
        <div className="w-8 h-8 border-2 border-brand border-t-transparent rounded-none animate-spin" />
      </div>
    )
  }

  if (!token) return <Navigate to="/login" replace />
  return children
}
